module.exports = __webpack_public_path__ + "static/ImagePlaceholder-5d7a0a3b9c29e242b23d05da7329a3da.png";